/**
 * Single source of truth for RBAC v2 feature flag.
 * Set REACT_APP_AUTHZ_V2=true in .env to force v2 for all users.
 * When the flag is off, v2 still activates for users whose profile includes rbac_grants.
 */

export function isAuthzV2Enabled() {
  return process.env.REACT_APP_AUTHZ_V2 === 'true';
}

/**
 * @param {object|null|undefined} userInfo
 */
export function hasRbacGrants(userInfo) {
  const grants = userInfo?.profile?.rbac_grants;
  if (!grants || typeof grants !== 'object') {
    return false;
  }

  const featureCount = Object.keys(grants.features || {}).length;
  const objectCount = Object.keys(grants.objects || {}).length;
  const accountCount = grants.resources?.accounts?.length || 0;
  const campaignCount = grants.resources?.campaigns?.length || 0;
  const recordActionCount = Object.keys(grants.record_actions || {}).length;

  return (
    featureCount > 0
    || objectCount > 0
    || accountCount > 0
    || campaignCount > 0
    || recordActionCount > 0
  );
}

/**
 * @param {object|null|undefined} userInfo
 */
export function resolveAuthzV2Enabled(userInfo) {
  return isAuthzV2Enabled() || hasRbacGrants(userInfo);
}
